import FONT_FAMILY from '../../../theme/FontsFamily';
import { styled, keyframes } from '@mui/system';

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
`;

export const Container = styled('div')({
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    boxSizing: 'border-box',
    overflowX: 'hidden'
});

export const ContactMainGrid = styled('div')({
    width: '98%',
    maxWidth: '1600px',
    margin: '0 auto',
    padding: '20px 0',
});

export const InfoBox = styled('div')({
    backgroundColor: 'transparent',
    padding: '0',
    height: '100%',
});

export const ContactCard = styled('div')({
    backgroundColor: 'white',
    padding: '20px',
    borderRadius: '12px',
    border: '1px solid #E2E8F0',
    boxShadow: '0 4px 12px rgba(0,0,0,0.03)',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    'html.dark &': {
        backgroundColor: '#000000',
        borderColor: '#222222',
    }
});

export const ContactLink = styled('a')({
    fontSize: '14px',
    lineHeight: '1.5',
    color: '#46464F',
    textDecoration: 'none',
    wordBreak: 'break-all',
    '&:hover': {
        color: '#202A5D',
        textDecoration: 'underline',
    },
    'html.dark &': {
        color: '#cbd5e1',
    },
    'html.dark &:hover': {
        color: '#ffffff',
    }
});

export const MapContainer = styled('div')({
    width: '100%',
    height: '500px',
    marginTop: '20px',
    overflow: 'hidden',
    borderTop: '1px solid #E2E8F0',
});

export const FormBox = styled('div')({
    backgroundColor: 'transparent',
    padding: '10px 0 20px 0',
});

export const SectionTitle = styled('h2')({
    fontFamily: FONT_FAMILY.bold.title,
    fontSize: '24px',
    color: '#1E293B',
    marginBottom: '25px',
    position: 'relative',
    '&:after': {
        content: '""',
        position: 'absolute',
        bottom: '-8px',
        left: 0,
        width: '40px',
        height: '3px',
        backgroundColor: '#202A5D',
    }
});